/**
 * Shared RTK Query option helpers to reduce distinct option types at call sites.
 * Using these instead of inline objects (e.g. `{ skip: !id }`) helps limit
 * TypeScript's type cache growth during type-check (Map size mitigation).
 */

export type SkipOption = { skip: boolean }

/**
 * Returns options with skip based on a boolean condition.
 * Use at every call site that would otherwise pass inline `{ skip: !value }`
 * so all sites share the same return type.
 */
export function skipWhen(condition: boolean): SkipOption {
  return { skip: condition }
}

/** Stable refetch option for use when multiple call sites need the same behavior. */
export const REFETCH_ON_MOUNT_OR_ARG_CHANGE_60 = {
  refetchOnMountOrArgChange: 60 as const
} as const
